var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 48,
    viewBox: "0 0 123 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.899 0H5.38311C2.4101 0 0 2.4101 0 5.38311V42.6169C0 45.5899 2.4101 48 5.38311 48H116.899C119.872 48 122.282 45.5899 122.282 42.6169V5.38311C122.282 2.4101 119.872 0 116.899 0Z",
    fill: "#FFDD2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8427 23.1423C59.2374 22.9095 58.4458 22.8397 57.5843 22.8397H52.7877V21.3495H61.0302V18.7883H49.4116V29.8714H57.2815C58.3759 29.8714 59.1907 29.7783 59.7962 29.5453C61.0769 29.0563 61.9383 27.8689 61.9383 26.3089C61.9383 24.7257 61.1233 23.6313 59.8427 23.1423ZM58.1663 26.9841C57.9801 27.0541 57.7239 27.0773 57.3978 27.0773H52.7877V25.3077H57.3978C57.7705 25.3077 58.0731 25.3312 58.306 25.4475C58.5854 25.5872 58.7251 25.8433 58.7251 26.1692C58.7251 26.4951 58.5622 26.8444 58.1663 26.9841Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4046 18.7883H66.4685L61.9281 29.8714H65.7467L66.3753 28.2648H71.4977L72.1497 29.8714H75.945L71.4046 18.7883ZM67.2135 25.8199L68.8202 21.3495H69.0762L70.6828 25.8199H67.2135Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2907 25.7503V29.8714H76.9147V18.7883H80.2907V22.8397H85.7159V18.7883H89.0921V29.8714H85.7159V25.7503H80.2907Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4359 25.6804V29.8714H91.0597V18.7883H94.4359V22.9561H95.3673L99.442 18.7883H103.679L98.2777 24.097L103.889 29.8714H99.3953L95.3673 25.6804H94.4359Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1625 11.6636H43.0783V25.2003C43.0783 28.6705 41.227 31.8772 38.2219 33.6124L29.6204 38.5793L21.0189 33.6124C18.0137 31.8772 16.1625 28.6705 16.1625 25.2003V11.6636Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5495 18.7883V22.9985C24.1252 22.3484 25.172 21.9084 26.3688 21.9084H27.6694V26.8027C27.6694 28.1048 27.3157 29.2445 26.7907 29.8714H32.4482C31.9244 29.2439 31.5714 28.1056 31.5714 26.8052V21.9084H32.8721C34.069 21.9084 35.1157 22.3484 35.6915 22.9985V18.7883H23.5495Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTBank);
export default __webpack_public_path__ + "static/media/t_bank.80a12d05c03fcd4abe5be57dfb0fa664.svg";
export { ForwardRef as ReactComponent };